

import { Layout } from "antd";
import SideNavBar from "../../Components/SideBar/Sidebar";
import Navbar from "../../Components/Support/Header";
import NewHiresReHires from "../../Components/NewHiresReHires/NewHiresReHires";


const NewHires = () => {
    const { Header, Content } = Layout;
    return (
        <div className="timecards-container">
            <Layout style={{ backgroundColor: "white", overflow: "hidden" }}>
                <SideNavBar />
                <Layout className="timecards-sub-layout-container">
                    <Header className="timecards-header">
                        <Navbar />
                    </Header>
                    <Content style={{overflowY:"hidden"}}>
                       <div>
                        <NewHiresReHires/>
                       </div>
                    </Content>
                </Layout>
            </Layout>
        </div>
    )
}

export default NewHires;
 